import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const items = ["Elegance", "Joy", "Making Memories", "Celebration", "Craft", "Delight", "Ritual", "Portraiture"];
  return (
    <section
      className="relative border-y border-black/10 bg-[#FDFBF7] py-4 md:py-6 overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <Marquee gradient={false} speed={30} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <span
            key={i}
            className="font-serif italic text-6xl md:text-8xl lg:text-9xl leading-none stroke-text mx-8"
          >
            {t} <span className="not-italic text-[#FF5722] mx-4">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
